import { render, staticRenderFns } from "./apdsContrato.vue?vue&type=template&id=6f0b24af&scoped=true"
import script from "./apdsContrato.vue?vue&type=script&lang=js"
export * from "./apdsContrato.vue?vue&type=script&lang=js"
import style0 from "./apdsContrato.vue?vue&type=style&index=0&id=6f0b24af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b24af",
  null
  
)

export default component.exports